/** Phase 19 F1: the 422 POC_MODEL_INCOMPLETE list from CMS-485 generation, ready to show. */
export interface PocMissingItem {
  discipline?: string;
  field: string;
  label: string;
  source: string;
  /** Where the user fixes it */
  where: string;
}

const WHERE: Record<string, string> = {
  carePlan: 'care plan',
  assessment: 'assessment',
  patient: 'patient admission (start of care date)',
  pocCertification: 'this certification',
  diagnoses: 'diagnosis list or assessment',
  demographics: 'demographics',
  medications: 'medications',
};

export function pocMissingItems(details: Record<string, unknown> | undefined): PocMissingItem[] {
  const raw = Array.isArray(details?.missing) ? details?.missing as unknown[] : [];
  return raw
    .filter((m): m is Record<string, unknown> => Boolean(m) && typeof m === 'object')
    .map(m => {
      const source = String(m.source || '');
      return {
        discipline: typeof m.discipline === 'string' ? m.discipline : undefined,
        field: String(m.field || ''),
        label: String(m.label || m.field || ''),
        source,
        where: WHERE[source] || source,
      };
    })
    .filter(m => m.field);
}
